import callApi from "./callApi";
import callRiwayatPaket from "./callRiwayatPaket";
import callRiwayatPesan from "./callRiwayatPesan";
import callDataOutlet from "./callDataOutlet";

const actions = {
    ...callApi,
    ...callRiwayatPaket,
    ...callRiwayatPesan,
    ...callDataOutlet,
    setListPerangkat: ({ commit }, payload) => {
        commit("setListPerangkat", payload);
    },
    resetListPerangkat: ({ commit }) => {
        commit("resetListPerangkat");
    },
    toggleDisplayItem: ({ commit }, payload) => {
        commit("toggleDisplayItem", payload);
    },
    resetPagination: ({ commit }) => {
        commit("resetPagination");
    },
    setEndItemofPage: ({ commit }, payload) => {
        commit("setEndItemofPage", payload);
    },

    setListPaket: ({ commit }, payload) => {
        commit("setListPaket", payload);
    },
    resetListPaket: ({ commit }) => {
        commit("resetListPaket");
    },
    toggleDisplayPaket: ({ commit }, payload) => {
        commit("toggleDisplayPaket", payload);
    },
    resetPagePaket: ({ commit }) => {
        commit("resetPagePaket");
    },

    setListPesan: ({ commit }, payload) => {
        commit("setListPesan", payload);
    },
    resetListPesan: ({ commit }) => {
        commit("resetListPesan");
    },
    toggleDisplayPesan: ({ commit }, payload) => {
        commit("toggleDisplayPesan", payload);
    },
    resetPagePesan: ({ commit }) => {
        commit("resetPagePesan");
    },

    setListOutlet: ({ commit }, payload) => {
        commit("setListOutlet", payload);
    },
    resetListOutlet: ({ commit }) => {
        commit("resetListOutlet");
    },
    toggleDisplayOutlet: ({ commit }, payload) => {
        commit("toggleDisplayOutlet", payload);
    },
    resetPageOutlet: ({ commit }) => {
        commit("resetPageOutlet");
    },

    setRegistered: ({ commit }, payload) => {
        commit("setRegistered", payload);
    },
    resetRegistered: ({ commit }) => {
        commit("resetRegistered");
    },
    resetResponse: ({ commit }) => {
        commit("setResponse", {});
    },
    setFetching: ({ commit }, payload) => {
        commit("setFetching", payload);
    },
    setFilter: ({ commit }, payload) => {
        commit("setFilter", payload);
    },
    setLoadMore: ({ commit }, payload) => {
        commit("setLoadMore", payload);
    },
    setResponse: ({ commit }, payload) => {
        commit("setResponse", payload);
    },
    setDataDeviceItem: ({ commit }, payload) => {
        commit("setDataDeviceItem", payload);
    },
    setVoucher: ({ commit }, payload) => {
        commit("setVoucher", payload);
    },
    setSelectedCustomer: ({ commit }, payload) => {
        commit("setSelectedCustomer", payload);
    },
    setQr: ({ commit }, payload) => {
        commit("setQr", payload);
    },
    setIntegrasiOutlet: ({ commit }, payload) => {
        commit("setIntegrasiOutlet", payload);
    },
    setDevice: ({ commit }, payload) => {
        commit("setDevice", payload);
    },
    resetDevice: ({ commit }) => {
        commit("resetDevice");
    },
    setDataDeviceTiny: ({commit}, payload) => {
        commit("setDataDeviceTiny", payload);
    },
    resetDataDeviceTiny: ({ commit }) => {
        commit("resetDataDeviceTiny");
    },
		setHistorySummary: ({ commit }, payload) => {
			commit("setHistorySummary", payload);
		}
};

export default actions;
